import { Fragment } from "react"
import type { FC, ReactElement } from "react"

import { ErrorBoundary } from "react-error-boundary"

import { ModalContainer } from "@/3514/components"
import { EModalId } from "@/3514/store/modal"

import EarlyContainer from "./attendance.early.modal.container"
import Container from "./attendance.modal.container"

const AttendanceModal: FC = (): ReactElement => (
    <ErrorBoundary fallback={<Fragment />}>
        <ModalContainer modalId={EModalId.AttendanceEarly} container={EarlyContainer} />
        <ModalContainer modalId={EModalId.Attendance} container={Container} />
    </ErrorBoundary>
)

AttendanceModal.displayName = "AttendanceModal"

export { AttendanceModal }
